/// <amd-module name="Build/Admin/Common/TaskAgentJobRequestUtils" />
import { equals, format } from "VSS/Core/Util/String";

import { ITeamProject } from "TFS/Services/TfsProjectService";

import { TaskAgentJobRequest } from "DistributedTask/Client/Contracts/TaskAgent";

import * as Resources from "Build/Admin/Common/Resources";

// While we have redirection logic in Distributed Task for image labels to agent specs
// it is possible that a job has an image label for its agent spec identifier. There is intentionally
// no map of these things that can be passed around from server to client, so we are creating this map manually.
//
// Keys are intentionally lower cased for lookup purposes
const imageLabelToAgentSpecName: { [key: string]: string } = {
    ["macos-1013"]: "macOS-10.13",
    ["macos 1013"]: "macOS-10.13",
    ["macos 10.13"]: "macOS-10.13",
    ["macos"]: "macOS-10.14",
    ["macos 10.14"]: "macOS-10.14",
    ["ubuntu16"]: "ubuntu-16.04",
    ["ubuntu 16.04"]: "ubuntu-16.04",
    ["defaulthosted"]: "vs2015-win2012r2",
    ["vs2015 win2012r2"]: "vs2015-win2012r2",
    ["vs2017"]: "vs2017-win2016",
    ["vs2017 win2016"]: "vs2017-win2016",
    ["wincon"]: "win1803",
    ["windows-2019-vs2019"]: "windows-2019",
    ["windows 2019 vs2019"]: "windows-2019",
    ["windows 2019"]: "windows-2019",
    ["mac_int1013"]: "appcenter-macos-10.13",
    ["appcenter macos 10.13"]: "appcenter-macos-10.13",
    ["mac_int"]: "appcenter-macos-10.14",
    ["appcenter macos 10.14"]: "appcenter-macos-10.14",
    ["xcode9-macos1012"]: "internal-macos-10.12",
    ["xcode9 macos1012"]: "internal-macos-10.12",
    ["internal macos 10.12"]: "internal-macos-10.12",
    ["mac_internal"]: "internal-macos-10.13",
    ["internal macos 10.13"]: "internal-macos-10.13",
    ["internal-macos1014"]: "internal-macos-10.14",
    ["internal macos1014"]: "internal-macos-10.14",
    ["internal macos 10.14"]: "internal-macos-10.14",
    ["ubuntu18"]: "ubuntu-18.04",
    ["ubuntu 18.04"]: "ubuntu-18.04"
};

export function getAgentSpecificationName(job: TaskAgentJobRequest): string {
    // Agent Specification is a jobject here. We only have one pool provider, and it uses "VMImage" as the name property.
    // There is no contract defined otherwise, and "VMImage" is not case sensitive, so we will need to look for it
    if (job && job.agentSpecification) {
        for (const key of Object.keys(job.agentSpecification)) {
            if (equals(key, "VMImage", true)) {
                let agentSpecName: string = job.agentSpecification[key];
                if (imageLabelToAgentSpecName[agentSpecName.toLowerCase()]) {
                    agentSpecName = imageLabelToAgentSpecName[agentSpecName.toLowerCase()];
                }
                return agentSpecName;
            }
        }
    }

    return "";
}


export function getProjectName(job: TaskAgentJobRequest, projects: ITeamProject[]): string {
    const project: ITeamProject | undefined = projects.filter(value => value.id === job.scopeId)[0];
    if (project && project.name) {
        return project.name;
    }
    else {
        return "";
    }
}

export function getJobNumber(job: TaskAgentJobRequest): string {
    return format(Resources.TaskAgentJobNumberFormat, job.requestId);
}
